import ApiServiceWrapper from './../../api-request.service';
import { MswApiStatusResponse } from '@/shared/types/api-common-types';

const widgetsApi = {
  getUserMgmt() {
    const reqEndPoint = 'users/get-usermanagement-info';
    return ApiServiceWrapper.get<MswApiStatusResponse>(reqEndPoint);
  },
  getLicenseStatus() {
    const reqEndPoint = 'users/licensestatus-widget-info';
    return ApiServiceWrapper.get<MswApiStatusResponse>(reqEndPoint);
  },
  getDownloadsAvailable() {
    const reqEndPoint = 'users/downloads-widget-info';
    return ApiServiceWrapper.get<MswApiStatusResponse>(reqEndPoint);
  }
  ,
  getSupportCases() {
    const reqEndPoint = 'support/get-supportcase-widget-info';
    return ApiServiceWrapper.get<MswApiStatusResponse>(reqEndPoint);
  },
};

export default widgetsApi;
